import theme from "../../assets/theme";
import {styled} from "styled-components";

const Loader = styled.div`
    &.lds_ring {
      position: relative;
      display: inline-block;
      width: 80px;
      height: 80px;
      margin: 56px auto;
      
      @media (prefers-reduced-motion: reduce) {
        > div { animation: none !important; }
      }
      > div {
        position: absolute;
        display: block;
        box-sizing: border-box;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid ${theme.accent};
        border-color: ${theme.accent} transparent transparent;
        border-radius: 50%;
        animation: loader-fade var(--motion-duration) var(--motion-enter) infinite alternate;
        

      }
    }
`

const LoaderWrap = () => {

    return (
        <Loader className='lds_ring' role='status' aria-label='로딩 중'>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </Loader>
    )
}

export default LoaderWrap;
